var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4935_148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.66684 3.6L9.00017 8.8V14M4.33345 3.6L5.00013 8.8V14M5.6668 1H8.3335M7.00015 1V3.6M12.4155 3.6H1.58476C1.49427 3.60002 1.40503 3.62052 1.32405 3.65989C1.24306 3.69925 1.17256 3.75641 1.11808 3.82685C1.0636 3.89729 1.02664 3.9791 1.0101 4.06584C0.993555 4.15258 0.997887 4.24187 1.02275 4.3267L1.78076 6.9137C2.04743 7.82175 2.1801 8.27545 2.5361 8.53805C2.89344 8.8 3.37678 8.8 4.34479 8.8H9.65551C10.6235 8.8 11.1075 8.8 11.4642 8.53805C11.8202 8.27545 11.9535 7.82175 12.2195 6.91435L12.9775 4.32735C13.0025 4.24248 13.007 4.15311 12.9905 4.06629C12.974 3.97947 12.937 3.89757 12.8826 3.82704C12.8281 3.75652 12.7575 3.6993 12.6765 3.6599C12.5954 3.6205 12.5061 3.59999 12.4155 3.6Z",
    stroke: "#E80A2B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4935_148"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStationIcon);
export default __webpack_public_path__ + "static/media/station-icon.086f99178bc5522a65a7b06d603d2874.svg";
export { ForwardRef as ReactComponent };